import React, { useState, useEffect } from "react"
import axios from "axios"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Spinner,
  CardImg,
  Input,
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import { getCurrentAcadid } from "store/Common/Actions"
import SubmitRemarks from "./SubmitRemarks"

const Home = () => {
  const dispatch = useDispatch()
  const baseUrl = "https://marcopolo.prisms.in/api/examfillmarks"

  const { acadID } = useSelector(state => state.CommonReducer)
  const token = JSON.parse(localStorage.getItem("Token"))
  const sid = localStorage.getItem("sid")

  const [isSubmit, setSubmit] = useState(false)
  const [studentList, setStudentList] = useState([])
  const [academic, setAcademic] = useState([])
  const [acad_id, setAcad_id] = useState("")
  const [div, setDiv] = useState([])
  const [studentId, setStudentId] = useState("")
  const [div_id, setDiv_id] = useState("")
  const [termData, setTermData] = useState([])
  const [term_id, setTerm_id] = useState("")
  const [loading, setLoading] = useState(false)

  const [stud, setStud] = useState({
    name: "",
    pic: "",
  })
  const [remarkData, setRemarkData] = useState([])
  const [selectedOptions, setSelectedOptions] = useState([])

  const getAcademicYear = async () => {
    try {
      const res = await axios({
        method: "GET",
        url: `${baseUrl}/get-Academic-year`,
        headers: {
          Authorization: token,
        },
      })
      setAcademic(res.data.data)
    } catch (error) {
      console.log("Error fetching academic year:", error)
    }
  }

  useEffect(() => {
    if (sid) {
      getAcademicYear()
      dispatch(
        getCurrentAcadid({
          sid,
        })
      )
    }
  }, [sid, dispatch])

  const getClassDiv = async () => {
    try {
      const res = await axios({
        method: "POST",
        url: `${baseUrl}/get-classdiv-list`,
        data: {
          acad_id: acad_id || acadID.acadid,
        },
        headers: {
          Authorization: token,
        },
      })
      setDiv(res.data.data)
    } catch (error) {
      console.log("Error fetching class divisions:", error)
    }
  }

  useEffect(() => {
    if (acad_id || acadID.acadid) {
      getClassDiv()
    }
  }, [acad_id, acadID.acadid])

  useEffect(() => {
    const getAllStudents = async () => {
      try {
        const response = await axios({
          method: "POST",
          url: `https://marcopolo.prisms.in/api/tscommon/getstudentdetails`,
          data: { sid, division: div_id },
        })
        setStudentList(response.data)
      } catch (error) {
        console.error("Error fetching students:", error)
      }
    }
    if (div_id) {
      getAllStudents()
    }
  }, [div_id, sid])

  useEffect(() => {
    const getTerm = async () => {
      setLoading(true)
      try {
        const res = await axios({
          method: "GET",
          url: `https://marcopolo.prisms.in/api/remark/select-term`,
          headers: {
            Authorization: token,
          },
        })
        setTermData(res.data.data)
        setLoading(false)
      } catch (error) {
        console.log("Error fetching terms:", error)
        setLoading(false)
      }
    }
    getTerm()
  }, [])

  const handleStud = e => {
    const { user_id, name, avatar } = JSON.parse(e.target.value)
    setStudentId(user_id)
    setStud(prev => ({
      ...prev,
      name: name,
      avatar: avatar,
    }))
  }

  useEffect(() => {
    const getFillRemark = async () => {
      try {
        const response = await axios({
          method: "POST",
          url: "https://marcopolo.prisms.in/api/remark/fill-remark",
          data: {
            acad_id: acad_id || acadID.acadid,
            user_id: [studentId],
            term_id: term_id,
            classdiv_id: div_id,
          },
          headers: {
            Authorization: token,
          },
        })

        const r1 = response.data.data

        setRemarkData(r1)
      } catch (error) {
        console.error("Error fetching fill remark:", error)
      }
    }

    if (
      isSubmit ||
      acad_id ||
      (acadID.acadid && div_id && term_id && studentId)
    ) {
      getFillRemark()
    }
  }, [acadID.acadid, acad_id, div_id, term_id, studentId, isSubmit])

  const t =
    remarkData.length > 0 && remarkData[0]?.remarkResult?.length > 0
      ? remarkData[0].remarkResult.map(item => ({
          label: item.remark_type,
          type_id: item.remark_type_id,
          checked_remark: item.checked_remark?.map( remark => {
            const key = remark.split(":")[0]?.trim()
            const value = remark.split(":")[1]?.trim() 
            return {
              label: value,
              value: key,
            }
          }),
          options: item.grouped_remarks.map(remark => {
            const key = remark.split(":")[0]?.trim()
            const value = remark.split(":")[1]?.trim()
            return {
              label: value,
              value: key,
            }
          }),
        }))
      : []

  return (
    <Row className="mt-5 py-4">
      <Container>
        <Card className="p-0">
          <CardBody className="p-3">
            <h1 className="text-center mb-4 fs-3" style={{ color: "#3c3c3c" }}>
              Fill Remarks
            </h1>

            {/* Academic Year */}
            <Row className="mb-4">
              <Col xl="12">
                <select
                  className="form-select"
                  onChange={e => setAcad_id(e.target.value)}
                >
                  <option value={acadID.acadid}>{acadID.academics}</option>
                  {academic.map(year => (
                    <option key={year.acadid} value={year.acadid}>
                      {year.academics}
                    </option>
                  ))}
                </select>
              </Col>

              {/* Term Dropdown */}
              <Col xl="12" className="mt-3">
                <select
                  className="form-select"
                  onChange={e => setTerm_id(e.target.value)}
                >
                  <option>Select Term</option>
                  {termData.map(item => (
                    <option key={item.id} value={item.termid}>
                      {item.termname}
                    </option>
                  ))}
                </select>
              </Col>

              {/* Division Dropdown */}
              <Col xl="12" className="mt-3">
                <select
                  className="form-select"
                  onChange={e => setDiv_id(e.target.value)}
                >
                  <option>Select Division</option>
                  {div.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.div_name}
                    </option>
                  ))}
                </select>
              </Col>

              {/* Student Dropdown */}
              <Col xl="12" className="mt-2">
                <select className="form-select" onChange={handleStud}>
                  <option>Select Student</option>
                  {studentList &&
                    studentList.map((item, indx) => (
                      <option
                        key={indx}
                        value={JSON.stringify({
                          user_id: item.user_id,
                          name: item.fname + " " + item.lname,
                          avatar: item.avatar,
                        })}
                      >
                        {item.fname + " " + item.lname}
                      </option>
                    ))}
                </select>
              </Col>
            </Row>

            <Col xl="12" className="mt-3">
              {studentId && (
                <Card className="shadow-sm rounded ">
                  <div className="text-center mb-3 mt-3">
                    <CardImg
                      alt="Profile"
                      className="rounded-circle"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                      }}
                      src={
                        stud.avatar
                          ? stud.avatar
                          : "https://ocisa.prisms.in/images/dashboard/student.png"
                      }
                    />
                  </div>
                  <span className="text-center text-dark fw-medium mb-3">
                    {stud.name}
                  </span>
                </Card>
              )}
            </Col>

            <SubmitRemarks
              token={token}
              t={t}
              user_id={studentId}
              acad_id={acad_id || acadID.acadid}
              term_id={term_id}
              div_id={div_id}
              setSubmit={setSubmit}
            />
          </CardBody>
        </Card>
      </Container>
      <ToastContainer />
    </Row>
  )
}

export default Home
